import React, {PureComponent} from "react";
import {
	Col,
	Form,
	Row
} from "react-bootstrap";


export class Condition extends PureComponent {
	render() {
		return (
			<Row>
				<Col>
					<Form.Group controlId="preConditionSelector">
						<Form.Label>
							Pre-Project Condition
						</Form.Label>
						<Form.Control
							as={"select"}
							placeholder={
								"Select a pre-development" +
								" biodiversity condition."
							}
							value={
								this.props.preCondition
							}
							onChange={
								(e) => {
									e.currentTarget.classList.remove(
										"is-invalid"
									);
									this.props.updateSite(
										"condition",
										parseFloat(e.currentTarget.value)
									);
								}
							}
						>
							<option value={"-1"}/>
							<option value={"3"}>
								Good
							</option>
							<option value={"2.5"}>
								Fairly Good
							</option>
							<option value={"2"}>
								Moderate
							</option>
							<option value={"1.5"}>
								Fairly Poor
							</option>
							<option value={"1"}>
								Poor
							</option>
						</Form.Control>
					</Form.Group>
				</Col>
				<Col>
					<Form.Group controlId="postConditionSelector">
						<Form.Label>
							Post-Project Condition
						</Form.Label>
						<Form.Control
							as={"select"}
							placeholder={
								"Select a post-development" +
								" biodiversity condition."
							}
							value={
								this.props.postCondition
							}
							onChange={
								(e) => {
									e.currentTarget.classList.remove(
										"is-invalid"
									);
									this.props.updateSite(
										"condition",
										parseFloat(e.currentTarget.value),
										false
									);
								}
							}
						>
							<option value={"-1"}/>
							<option value={"3"}>
								Good
							</option>
							<option value={"2.5"}>
								Fairly Good
							</option>
							<option value={"2"}>
								Moderate
							</option>
							<option value={"1.5"}>
								Fairly Poor
							</option>
							<option value={"1"}>
								Poor
							</option>
						</Form.Control>
					</Form.Group>
				</Col>
			</Row>
		)
	}
}
